import { render, staticRenderFns } from "./StationVersions.vue?vue&type=template&id=054cc6ab&scoped=true&"
import script from "./StationVersions.vue?vue&type=script&lang=js&"
export * from "./StationVersions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054cc6ab",
  null
  
)

export default component.exports